import { render } from "./StarXpGate.vue?vue&type=template&id=5218d2c1&scoped=true&ts=true"
import script from "./StarXpGate.vue?vue&type=script&lang=ts"
export * from "./StarXpGate.vue?vue&type=script&lang=ts"

import "./StarXpGate.vue?vue&type=style&index=0&id=5218d2c1&scoped=true&lang=css"
import "./StarXpGate.vue?vue&type=style&index=1&id=5218d2c1&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5218d2c1"]])

export default __exports__